


































































import { Vue, Component } from "vue-property-decorator";
import { auth, VIPCapability, db, VIPCapabilityRest, VipCapabilityStatus, VIPIp, IRestResult, VipCapabilityRequestStatus, VIPCapabilityRequestRest, busy, createEventInfo } from '@/loader';
import CapabilitiesTable from "../component/capability/CapabilitiesTable.vue";
import CapabilityRequestsTable from "../component/capability-request/CapabilityRequestsTable.vue";
import CapabilityStatusBadge from "../component/capability/CapabilityStatusBadge.vue";
import IpTree from "../component/ip/IpTree.vue";
import { vip } from '../store/VIPModule';
import dayjs from "dayjs";

var capacityLoaded = false;

@Component({
	components: {
		CapabilitiesTable,
		CapabilityRequestsTable,
		CapabilityStatusBadge,
		IpTree,
	}
})
export default class CapabilitiesView extends Vue {
	public newCap: VIPCapability | null = null;
	public sortBy = "date";
	public sortDesc = true;

	public get canCreate(): boolean {
		return auth.user?.capabilities.create_vip_capability || false;
	}

	public get canCreateRequest(): boolean {
		return auth.user?.capabilities.create_vip_capability_request || false;
	}

	public get active(): VIPCapability[] {
		return db.capabilities.list.filter(c => c.isActive);
	}

	public get ips(): VIPIp[] {
		// @ts-ignore
		return this.active.map(c => c.ip);
	}

	public get capability() {
		return (ip: VIPIp) => this.active
			.filter(c => c.ip === ip)
			.sort((a, b) =>
				a.end && b.end // If both end dates are defined
					? b.end?.diff(a.end) // Sort by end date descending
					: a.date && b.date // Else if both start dates are defined
						? b.date.diff(a.date) // Sort by start date descending
						: b.id - a.id) // Else Sort by Id descending
			.shift();
	}

	public createCapability() {
		if (this.canCreate) {
			vip.createCapability();
			// this.newCap = db.capabilities.insert({ id: db.capabilities.list.nextNewId() });
			// this.$bvModal.show("new_capability_modal");
		}
	}

	public createCapabilityRequest() {
		if (this.canCreateRequest) {
			var item = db.capabilityRequests.insert({
				id: db.capabilityRequests.list.nextNewId(),
				date: dayjs(),
				status: VipCapabilityRequestStatus.draft
			});
			item.event = createEventInfo();

			busy.start("Création d'une nouvelle demande de capacité ...");
			console.log(item);
			VIPCapabilityRequestRest.create(item).then(result => {
				if (result.success && result.item) {
					this.$router.push({ name: "CapabilityRequest", params: { id: result.item.id.toString() } });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	public viewCapability(cap: VIPCapability | null) {
		if (cap) {
			this.$router.push({ name: "Capability", params: { id: cap.id.toString() } });
		}
	}

	public selectIp(ip: VIPIp | null) {
		if (ip) {
			this.viewCapability(this.capability(ip) || null);
		}
	}

	// public capabilityCreated() {
	// 	if (this.newCap) {
	// 		this.viewCapability(this.newCap);
	// 		this.newCap = null;
	// 	}
	// }

	// public cancelCreation() {
	// 	this.cap = null;
	// }

	public async mounted() {
		if (!capacityLoaded) {
			capacityLoaded = true;
			const per_page = 100;
			let result: IRestResult<VIPCapability> | null = null;
			let page = 1;
			do {
				result = await VIPCapabilityRest.list({
					status: VipCapabilityStatus.signed,
					orderby: "date",
					order: "DESC",
					page,
					per_page
				});
				if (result.success && result.total && Math.ceil(result.total / per_page) > page) {
					page++;
				} else  {
					break;
				}
			} while (result.success);
		}
	}
}
